export const environment = {
    production: false,
    baseApiUrl: 'https://localhost:7059',
    apiUrl: 'https://localhost:7059',
    sendEmailUrl: '.'
};
